import { useEffect } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import CreateSystemForm from "../../components/create-system-form";
import WithNavigation from "../../hoc/with-navigation";
import { useSystem } from "../../store/system";

import "./styles.css";

const UpdateSystem: React.FC = () => {
	const history = useHistory();
	const { id } = useParams() as any;
	const systemStore = useSystem();

	const handleSubmit = (data) => {
		delete data.id;
		systemStore.update(id, data);
	};

	useEffect(() => {
		systemStore.get(id);

		return () => {
			systemStore.reset();
		};
	}, []);

	useEffect(() => {
		if (systemStore.updatedSystemId) {
			history.replace(`/system/${systemStore.updatedSystemId}`);
		}
	}, [systemStore.updateReqInfo]);

	return (
		<WithNavigation preventGoBack={false} text={`Edit ${systemStore.system?.name || 'system'}`}>
			{systemStore.system && (
				<CreateSystemForm
					defaultState={systemStore.system}
					submitLabel="Actualizar"
					onSubmit={handleSubmit}
				/>
			)}
		</WithNavigation>
	);
};

export default UpdateSystem;
